import axios from 'axios';
import _ from 'lodash';

import { TOKEN, SESSION_CREATE_TIME } from '../constants/global';

axios.defaults.withCredentials = true;

export const PRODUCTION = 'production';
export const DEVELOPMENT = 'development';
export const STAGING = 'staging';
export const LOCAL = 'local';

const basicConfig = {
  [PRODUCTION]: {
    // apiUrl: 'https://imc3-bq-checker-lhxssr3efq-de.a.run.app/imc3-bq-checker/api',
    apiUrl: 'https://imc3bq.haitechservice.com/imc3-bq-checker/api',
    folderName: '/',
    GOOGLE_CLIENT_ID:'157792159170-s7at1ehao18rhdg72fbjiunu561ci4lh.apps.googleusercontent.com',
    showVersion: false,
    version: PRODUCTION,
    versionName: 'Basic Version'
  },
  [DEVELOPMENT]: {
    apiUrl: 'https://imc3bq.haitechservice.com/imc3-bq-checker/api',
    folderName: '/bqwork_dev',
    GOOGLE_CLIENT_ID:'157792159170-s7at1ehao18rhdg72fbjiunu561ci4lh.apps.googleusercontent.com',
    showVersion: true,
    version: DEVELOPMENT,
    versionName: '開發版'
  },
  [STAGING]: {
    apiUrl: 'https://imc3bq.haitechservice.com/imc3-bq-checker/api',
    folderName: '/bqwork_demo',
    GOOGLE_CLIENT_ID:'157792159170-s7at1ehao18rhdg72fbjiunu561ci4lh.apps.googleusercontent.com',
    showVersion: true,
    version: STAGING,
    versionName: '測試版'
  },
  [LOCAL]: {
    apiUrl: '/api',
    folderName: '',
    GOOGLE_CLIENT_ID:'157792159170-s7at1ehao18rhdg72fbjiunu561ci4lh.apps.googleusercontent.com',
    showVersion: true,
    version: LOCAL,
    versionName: '本機版'
  }
}

const currentStage = PRODUCTION;
// const currentStage = DEVELOPMENT;
// const currentStage = STAGING;
// const currentStage = LOCAL;

// api link
export const baseUrl = basicConfig[currentStage];

export const apiRequest = axios.create({
  baseURL: baseUrl.apiUrl,
})

export const apiList = {
  // User Status
  systemLogin: (data, config) => apiRequest.post('/authentication/system_login', data, config),
  googleLogin: (data, config) => apiRequest.post(`/authentication/google_login?${data}`),
  loginout: (data, config) => apiRequest.post('/authentication/revoke', data, config),
  checkUserStatus: (data, config) => apiRequest.get('/authentication/me'),

  // Work (Account)
  getWorkList: (data, config) => apiRequest.get(`/manual_run/job/list?${data}`),
  createWork: (data, config) => apiRequest.post(`/manual_run/job?${data}`),
  deleteWork: (data, config) => apiRequest.delete(`manual_run/job?${data}`),

  // Work v2(Client)
  getClientList: (data, config) => apiRequest.get(`/manual_run_v2/account_bundle/list`),
  getClientWorkList: (data, config) => apiRequest.get(`/manual_run_v2/job/list?${data}`),
  createClientWork: (data, config) => apiRequest.post(`/manual_run_v2/job?${data.param}`, data.body),
}

export const handleApiRequest = (apiName, body, config) => {
  return apiList[apiName](body, {
    ...config
  })
    .then(res => {
      return res;
    })
    .catch(err => {
      return err.response || err;
    })
}

export const getCancelData = () => {
  return axios.CancelToken.source();
};

export const getToken = () => {
  return localStorage.getItem('token');
}

export const removeStorageRecord = () => {
  localStorage.removeItem(TOKEN);
  localStorage.removeItem(SESSION_CREATE_TIME);
  localStorage.removeItem('user');
}
